import React, { FC, ReactNode } from 'react'
import { Tooltip, TooltipProps } from 'antd'
import cx from 'classnames'
import styles from './Tooltip.module.scss'

type ICustomTooltip = TooltipProps & {
  header?: string | ReactNode | ReactNode[]
  mainTextContentClassName?: string
}

const CustomTooltip: FC<ICustomTooltip> = ({
  header,
  title,
  color,
  placement,
  classNames = {},
  mainTextContentClassName,
  ...props
}) => {
  const renderTitle = () => {
    if (typeof title === 'function') {
      return title()
    }

    return header ? (
      <>
        <div className={styles.header}>{header}</div>
        <div className={cx(styles.mainTextContent, mainTextContentClassName)}>{title}</div>
      </>
    ) : (
      <div className={cx(styles.mainTextContent, mainTextContentClassName)}>{title}</div>
    )
  }

  return (
    <Tooltip
      {...props}
      color={color || '#fff'}
      placement={placement || 'topLeft'}
      classNames={{ root: cx(classNames.root, styles.root), body: cx(classNames.body, styles.body) }}
      title={renderTitle}
    />
  )
}

export default CustomTooltip
